document.addEventListener("DOMContentLoaded", function () {
  // console.log("Homepage JS loaded");

  const params = new URLSearchParams(window.location.search);

  const mcCid = params.get("mc_cid");
  const mcEid = params.get("mc_eid");

  // Exception: stop script if the exact parameters match
  if (mcCid === "e458ddcf75" && mcEid === "77c6101b12") {
    //console.log("FROM Newsletter JS loaded");
    window.location.replace("https://shop.hammambasar.ch/collections/fruhlingsenergie");
    return;
  }
});